// @ts-check
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

function formattedHeadline(headline) {
    return headline.replace(/--/g, "&shy;");
}

const Title = ({ Title, IsTitleH1, IsTitleH3, id }) => {
    const baseClass = "title";
    const titleClass = classNames(baseClass, "u-text-word-break-word", {
        [`${baseClass}--small`]: IsTitleH3
    });

    const TitleElement = IsTitleH1 ? "h1" : IsTitleH3 ? "h3" : "h2";

    return (
        <TitleElement
            id={id}
            className={titleClass}
            dangerouslySetInnerHTML={{ __html: formattedHeadline(Title) }}
        />
    );
};

Title.propTypes = {
    Title: PropTypes.string,
    IsTitleH1: PropTypes.bool,
    IsTitleH3: PropTypes.bool
};

export default Title;
